import { memo, useCallback } from 'react';
import { useRouter } from 'next/navigation';
import { css } from '@emotion/css';
import { VStack } from '@cbhq/cds-web/layout';
import { TextTitle3, TextBody } from '@cbhq/cds-web/typography';
import { Button } from '@cbhq/cds-web/buttons/Button';

const emptyStateStyles = css`
  min-height: 420px;
`;

export const TangorEquitiesEmptyState = memo(function TangorEquitiesEmptyState() {
  const router = useRouter();

  const handleExploreClick = useCallback(() => {
    router.push('/?tab=tokenized-equities');
  }, [router]);

  return (
    <VStack
      testID="tangor-equities-empty-state"
      className={emptyStateStyles}
      background="bg"
      borderRadius={400}
      justifyContent="center"
      alignItems="center"
      gap={1.5}
      paddingX={5}
      paddingY={10}
    >
      <VStack alignItems="center" gap={0}>
        <TextTitle3 as="p">No equities owned</TextTitle3>
        <TextBody as="p" color="fgMuted">
          Explore available stock tokens in the Explore page.
        </TextBody>
      </VStack>
      <Button variant="primary" onClick={handleExploreClick}>
        Explore equities
      </Button>
    </VStack>
  );
});
